/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import {deleteLocalStorage} from '@ion/core/src/capabilities/storage';
import {error as logger} from '@ion/core/src/logger/logger';
import {setArcGISErrorHandler} from '@ion/core/src/services/ArcGISUtils';
import {setConnectErrorHandler} from '@ion/core/src/services/ConnectUtils';
import {ServiceError} from '@ion/core/src/types/services';
import {ApplicationKeys} from '@/types/application';
import {getRoute, Route} from '../../routes/RouteDefinitions';

export const SERVICE_ERROR         = 'SERVICE_ERROR';
export const SERVICE_ERROR_RETRY   = 'SERVICE_ERROR_RETRY';
export const SERVICE_ERROR_DISMISS = 'SERVICE_ERROR_DISMISS';

/**
 * @addErrorInterceptor
 *
 * Provides the initialization hook for adding global error interceptors.
 */
export const addErrorInterceptor = dispatch => {
  const interceptor = (error: ServiceError) => {
    dispatch(serviceError(error));
    logger(`iOn Service Error [${error.status || 'N/A'}]`);
    return Promise.reject(error);
  };
  setConnectErrorHandler(interceptor);
  setArcGISErrorHandler(interceptor);
};

/**
 * @globalServiceError
 *
 * Dispatched when a global service error occurs in iOn, at which point the
 * error reducer state is updated and the user is notified of the error.
 */
export const serviceError = (error: ServiceError) => {
  return {type: SERVICE_ERROR, error};
};

/**
 * @retry
 *
 * Dispatched when a user chooses to retry a the operation which causes the global
 * service error to occur.
 */
export const retry = () => {
  return {type: SERVICE_ERROR_RETRY};
};

/**
 * @dismiss
 *
 * Dispatched when the user chooses to dismiss a global service error notification.
 */
export const dismiss = () => {
  return {type: SERVICE_ERROR_DISMISS};
};

/**
 * @restart
 *
 * Dispatched when the user chooses to log back in after being notified that thier
 * session has expired.
 */
export const restart = () => {
  return async dispatch => {
    deleteLocalStorage(ApplicationKeys.iOnSuiteSession);
    location.assign(getRoute(Route.LOGIN));
  };
};
